export class Organisation {

    constructor(
      public id: number,
      public authority: string | null,
      public department: string | null,
      public entity: string | null,
      public unit: string | null,
      public licence: string,
      public job_titles: string[],
      public is_validated: boolean,
    ) {
      this.id = id
      this.authority = authority
      this.department = department
      this.entity = entity
      this.unit = unit
      this.licence = licence
      this.job_titles = job_titles
      this.is_validated = is_validated
    }
  }
